import React, { useState, useEffect, useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ExitIcon from '@mui/icons-material/ExitToApp';
import OfferIcon from '@mui/icons-material/LocalOffer';
import NotifyIcon from '@mui/icons-material/NotificationsActive';
import QrCodeIcon from '@mui/icons-material/QrCode';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { api } from 'common';
import { colors } from '../components/Theme/WebTheme';
import { ThemeContext } from './Theme/ThemeContext';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useTranslation } from "react-i18next";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CallToActionIcon from '@mui/icons-material/CallToAction';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MoneyIcon from '@mui/icons-material/Money';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { calcEst, showEst, optionsRequired } from '../common/sharedFunctions';
import SosIcon from '@mui/icons-material/Sos';
import { MAIN_COLOR, ACCENT_COLOR } from "../common/sharedFunctions"
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';



const drawerWidth = 260;

export default function ResponsiveDrawer(props) {
  const { isDark } = useContext(ThemeContext);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {
    signOff
  } = api;
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();

  const LogOut = () => {
    dispatch(signOff());
  };

  const location = useLocation();

  const [role, setRole] = useState(null);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawer = () => {
    setMobileOpen(false);
  };

  const drawer = (
    <div style={{
      background: 'linear-gradient(180deg, #08080A 0%, #151518 100%)',
      height: '100%',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px 20px',
        borderBottom: '1px solid rgba(255,255,255,0.08)'
      }}>
        <img style={{ width: '120px', height: 'auto', filter: 'drop-shadow(0 0 8px rgba(255,255,255,0.15))' }} src={require("../assets/img/logo138x75white.png").default} alt="Logo" />
      </div>
      <div style={{ flexGrow: 1, overflowY: 'auto' }}>
        {role ?
          <List disablePadding={true} dense={false} style={{ padding: '10px' }}>
            {[
              { name: t('home'), url: '/', icon: <HomeIcon />, access: ['admin', 'fleetadmin', 'driver', 'customer'] },
              { name: t('driver_home'), url: '/driver-home', icon: <HomeIcon />, access: ['driver'] },
              { name: t('dashboard_text'), url: '/dashboard', icon: <DashboardIcon />, access: ['admin', 'fleetadmin'] },
              { name: t('booking_history'), url: '/bookings', icon: <ViewListIcon />, access: ['admin', 'fleetadmin', 'driver', 'customer'] },
              { name: t('addbookinglable'), url: '/addbookings', icon: <ContactPhoneIcon />, access: calcEst && !showEst && !optionsRequired ? ['customer'] : ['admin', 'fleetadmin', 'customer'] },

              { name: t('user'), url: '/users/0', icon: <EmojiPeopleIcon />, access: ['admin', 'fleetadmin'] },

              { name: t('car_type'), url: '/cartypes', icon: <CarIcon />, access: ['admin'] },
              { name: t('cars'), url: '/cars', icon: <CarIcon />, access: ['admin', 'fleetadmin', 'driver'] },

              { name: t('withdraws_web'), url: '/withdraws', icon: <MoneyIcon />, access: ['admin'] },
              { name: t('add_to_wallet'), url: '/addtowallet', icon: <AccountBalanceWalletIcon />, access: ['admin'] },
              { name: 'Deduct From Wallet', url: '/deductfromwallet', icon: <CallToActionIcon />, access: ['admin'] },
              { name: t('report'), url: '/allreports', icon: <AssessmentIcon />, access: ['admin', 'fleetadmin'] },
              { name: t('promo'), url: '/promos', icon: <OfferIcon />, access: ['admin'] },
              { name: t('push_notifications'), url: '/notifications', icon: <NotifyIcon />, access: ['admin'] },
              { name: t('sos'), url: '/sos', icon: <SosIcon />, access: ['admin'] },
              { name: 'Call Logs', url: '/call-logs', icon: <PhoneIphoneIcon />, access: ['admin', 'fleetadmin'] },
              { name: t('complain'), url: '/complain', icon: <AnnouncementOutlinedIcon />, access: ['admin'] },
              { name: t('my_wallet_tile'), url: '/userwallet', icon: <AccountBalanceWalletIcon />, access: ['driver', 'customer'] },
              { name: t('settings_title'), url: '/settings', icon: <PhoneIphoneIcon />, access: ['admin'] },
              { name: t('payment_settings'), url: '/paymentsettings', icon: <PhoneIphoneIcon />, access: ['admin'] },
              {name: t('generate_qr'), url: '/generate-qr', icon: <QrCodeIcon />, access: ['admin']},
              {name: 'Scan Analytics', url: '/scan-analytics', icon: <QrCodeScannerIcon />, access: ['admin']},
              {name: t('batch_lookup'), url: '/batch-lookup', icon: <FindInPageIcon />, access: ['admin']},
              {name: t('batch_details'), url: '/batch-details', icon: <ListAltIcon />, access: ['admin']},
              {name: t('profile'), url: '/profile', icon: <AccountCircleIcon />, access: ['admin', 'fleetadmin', 'driver', 'customer']},
              {name: t('logout'), url: 'logout', icon: <ExitIcon />, access: ['admin', 'fleetadmin', 'driver', 'customer']}
            ].map((item, index) => {
              const isActive = location.pathname === item.url || (item.url !== '/' && location.pathname.startsWith(item.url));
              return (
                item.access.includes(role) ?
                  <div style={{ display: 'flex', margin: '5px 0' }} key={"key" + index}>
                    <ListItem key={item} disableGutters={true} disablePadding={true} alignItems='center' dense={false} onClick={handleDrawer}>
                      <ListItemButton
                        disableGutters={true}
                        dense={false}
                        component={Link}
                        to={item.url === 'logout' ? null : item.url}
                        onClick={item.url === 'logout' ? LogOut : null}
                        style={{
                          borderRadius: '12px',
                          background: isActive ? 'linear-gradient(90deg, rgba(233, 174, 49, 0.15) 0%, rgba(233, 174, 49, 0.03) 100%)' : 'transparent',
                          borderLeft: isActive ? '4px solid #E9AE31' : '4px solid transparent',
                          paddingLeft: '15px',
                          transition: 'all 0.2s ease-in-out'
                        }}
                        sx={{
                          '&:hover': {
                            background: isActive ? 'linear-gradient(90deg, rgba(233, 174, 49, 0.2) 0%, rgba(233, 174, 49, 0.05) 100%) !important' : 'rgba(255, 255, 255, 0.05) !important',
                            '& .MuiListItemIcon-root': {
                              color: '#E9AE31'
                            }
                          }
                        }}
                      >
                        <ListItemIcon className={isActive ? "active-icon-wrapper" : ""} style={{ color: isActive ? '#E9AE31' : 'rgba(255,255,255,0.6)', minWidth: '40px' }}>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.name}
                          primaryTypographyProps={{
                            style: {
                              color: isActive ? '#FFFFFF' : 'rgba(255,255,255,0.6)',
                              textAlign: isRTL === 'rtl' ? 'right' : 'left',
                              fontWeight: isActive ? 600 : 400,
                              fontSize: '0.95rem'
                            }
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  </div>
                  : null
              )
            })}
          </List>
          : null}
      </div>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        sx={{
          display: { xs: 'block', sm: 'none' },
          background: 'linear-gradient(180deg, #08080A 0%, #151518 100%)',
          boxShadow: 'none',
          borderBottom: '1px solid var(--border-color)',
          zIndex: 1100
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon style={{ color: '#E9AE31' }} />
          </IconButton>
          <Typography variant="h6" noWrap component="div" style={{ color: 'var(--text-main)', fontWeight: 700, fontFamily: 'Outfit, sans-serif' }}>
            {settings && settings.appName && settings.appName !== "MOVE" && settings.appName !== "Move" ? settings.appName : 'Rahl'}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { 
              boxSizing: 'border-box', 
              width: drawerWidth,
              borderRight: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid rgba(233, 174, 49, 0.15)',
              background: 'linear-gradient(180deg, #08080A 0%, #151518 100%)'
            }, 
            direction: isRTL === 'rtl' ? 'rtl' : 'ltr'
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { 
              boxSizing: 'border-box', 
              width: drawerWidth,
              borderRight: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid rgba(233, 174, 49, 0.15)',
              background: 'linear-gradient(180deg, #08080A 0%, #151518 100%)'
            }, 
            direction: isRTL === 'rtl' ? 'rtl' : 'ltr'
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 0, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar sx={{ display: { xs: 'block', sm: 'none' } }} />
        {props.children}
      </Box>
    </Box>
  );
}
